import { relations } from 'drizzle-orm';
import { pgTable, primaryKey, uuid } from 'drizzle-orm/pg-core';
import { userTable } from './user.sql';
import { teamTable } from './team.sql';

export const userTeamTable = pgTable(
  'user_team',
  {
    userId: uuid('userId')
      .notNull()
      .references(() => userTable.id),
    teamId: uuid('teamId')
      .notNull()
      .references(() => teamTable.id),
  },
  (t) => [primaryKey({ columns: [t.teamId, t.userId] })],
);

export const userTeamRelations = relations(userTeamTable, ({ one }) => ({
  user: one(userTable, {
    fields: [userTeamTable.userId],
    references: [userTable.id],
  }),
  team: one(teamTable, {
    fields: [userTeamTable.teamId],
    references: [teamTable.id],
  }),
}));
